/**
 * Tradutor de falha para frase util.
 *
 * CLAUDE.md, "Regras de interface", item 8: a mensagem diz o que fazer e nunca
 * mostra erro tecnico. `login_required`, `invalid_grant` e 401 nao sao frases:
 * sao codigo de protocolo, e o usuario nao tem o que fazer com eles.
 *
 * O detalhe tecnico nao e engolido — vai para o console de erro do navegador,
 * onde o suporte olha, junto do identificador de correlacao que a API devolve.
 */

export const MENSAGEM_GENERICA = 'Não foi possível concluir. Tente de novo em instantes.';

export const MENSAGEM_SESSAO_ENCERRADA =
  'Sua sessão foi encerrada. Entre novamente para continuar.';

export const MENSAGEM_INATIVIDADE =
  'Sua sessão expirou por inatividade. Entre novamente para continuar.';

export const MENSAGEM_ENTRE_PARA_CONTINUAR = 'Entre no sistema para continuar.';

/**
 * Codigos que o Keycloak devolve na volta do fluxo de autorizacao, na propria
 * URL. Ver RFC 6749, secao 4.1.2.1, e o acrescimo do OpenID Connect.
 */
const POR_CODIGO_OAUTH: Record<string, string> = {
  access_denied: 'A entrada foi interrompida. Tente novamente quando quiser.',
  login_required: MENSAGEM_ENTRE_PARA_CONTINUAR,
  interaction_required: MENSAGEM_ENTRE_PARA_CONTINUAR,
  consent_required: MENSAGEM_ENTRE_PARA_CONTINUAR,
  account_selection_required: MENSAGEM_ENTRE_PARA_CONTINUAR,
  temporarily_unavailable:
    'O serviço de autenticação está indisponível neste momento. Tente de novo em alguns minutos.',
  invalid_grant: 'Este link de entrada não vale mais. Entre novamente.',
  // As demais falhas de protocolo (invalid_request, unauthorized_client,
  // unsupported_response_type, invalid_scope, server_error) sao defeito de
  // configuracao nossa. O usuario nao consegue resolver, entao recebe a frase
  // generica e o detalhe fica no console.
};

export function mensagemDoCodigoOauth(codigo: string | null | undefined): string {
  if (!codigo) {
    return MENSAGEM_GENERICA;
  }
  return POR_CODIGO_OAUTH[codigo] ?? MENSAGEM_GENERICA;
}

/** Mensagem por situacao HTTP, quando a API nao mandou frase propria. */
const POR_SITUACAO: Record<number, string> = {
  400: 'Confira o preenchimento e tente de novo.',
  401: MENSAGEM_SESSAO_ENCERRADA,
  403: 'Você não tem permissão para esta ação.',
  404: 'Não encontramos o que você procura.',
  429: 'Muitas tentativas. Aguarde alguns minutos e tente de novo.',
};

/**
 * A API do TEG responde `{ situacao, mensagem, correlacao }` e a `mensagem` ja
 * vem em portugues, escrita para o usuario (apps/api/src/nucleo/erros/
 * filtro-excecao.ts). Entao ela e aproveitada — repetir o texto aqui seria
 * duas fontes da mesma verdade, que divergem na primeira correcao.
 *
 * Quando o corpo nao tem frase — falha de rede, resposta vazia, servico fora —
 * entra a frase por situacao.
 */
export function mensagemDaApi(situacao: number, corpo: unknown): string {
  if (corpo && typeof corpo === 'object') {
    const { mensagem } = corpo as { mensagem?: unknown };
    if (typeof mensagem === 'string' && mensagem.trim().length > 0) {
      return mensagem;
    }
  }
  return POR_SITUACAO[situacao] ?? MENSAGEM_GENERICA;
}

/** Falha de rede: o servico nem respondeu. */
export const MENSAGEM_SEM_RESPOSTA =
  'Não conseguimos falar com o sistema. Verifique sua conexão e tente de novo.';
